export const TYPOGRAPHY_VARIANTS = [
  'h0',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'title1',
  'title2',
  'title3',
  'title4',
  'title5',
  'title6',
  'body1',
  'body2',
  'body3',
  'body4',
  'body5',
  'link_12',
  'link_14',
  'link_15',
  'caption1',
  'caption2',
  'caption3',
  'caption4',
  'caption5'
] as const;

export const HEADING_VARIANTS = ['h0', 'h1', 'h2', 'h3', 'h4', 'h5'];

export const P_VARIANTS = [
  'caption1',
  'caption2',
  'caption3',
  'caption4',
  'caption5'
];

export const HTML_TAG_VARIANTS = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'p',
  'span'
] as const;
